import createConfig from './createConfig';
import SznDiscussion from './interface/SznDiscussion';

function getWrapperElement(element) {
	if (typeof element === 'string') {
		element = window.document.getElementById(element);
	}

	return element instanceof HTMLElement ? element : null;
}

export function createDiscussion(element, configuration = {}) {
	element = getWrapperElement(element);

	if (!element) {
		throw new Error(
			'SznDiscussion: Cannot create iframe for embedded discussion. ' +
				'Provided element or ID is does not exist.'
		);
	}

	const config = createConfig(configuration);
	const instance = new SznDiscussion(element, config);

	return {
		load: instance.load.bind(instance),
		listen: instance.listen.bind(instance),
		unlisten: instance.unlisten.bind(instance),
		unload: instance.unload.bind(instance)
	};
}
